import { render, staticRenderFns } from "./my-comments.vue?vue&type=template&id=cc65b328&scoped=true&lang=html&"
import script from "./my-comments.vue?vue&type=script&lang=js&"
export * from "./my-comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc65b328",
  null
  
)

export default component.exports